import React from 'react';
import {img} from '../utils/img';
import {stands} from '../utils/stands_id';
import {mirrors} from '../utils/mirrors_id';
import {modelSinks} from '../utils/img';
import deleteImg from './../assets/img/Delete.jpg';
import { sinks } from '../utils/sinks_id';

import {apiConstructor} from '../api/ConstructorApi';


export default class OptionsList extends React.Component {
    constructor(props) {
        super(props);
    }

    _getMirrorList(mirror) {
        apiConstructor.getMirrorsList(encodeURIComponent(mirror.fileName)).then(res => {
            this.props.updateMirrorList(res.data);
            this.props.initModal(mirror.description, mirror.img);
        })
        .then(res => {
            
            this.props.setStatusWindow({value: true, type: 'mirror'});
            this.props.updatePreloader(false);
        })
    }


    _getStandList(stand) {
        const loadImage = image => {
            return new Promise((resolve, reject) => {
                const loadImg = new Image()
                loadImg.src = image
                // wait 2 seconds to simulate loading time
                if(image === undefined || image === "" || image === false) {
                    resolve(image)
                }
                loadImg.onload = () =>
                setTimeout(() => {
                    resolve(image)
                }, 2000)
                loadImg.onerror = err => reject(err)
            })
        }

        this.props.updatePreloader(true);
        apiConstructor.getStandsList(stand.fileName).then(res => {
            this.props.updateStandList(res.data);
            this.props.initModal(stand.description, stand.img);
            Promise.all(stand.img.map(image => loadImage(image)))
            .then(res => {
                this.props.setStatusWindow({value: true, type: 'stand'});
                this.props.updatePreloader(false);
            })
        })
    }

    _getCabinetList(cabinet) {
        apiConstructor.getCabinetList(cabinet.fileName).then(res => {
            this.props.updateCabinetsList(res.data);
            this.props.initModal(cabinet.description, cabinet.img);
        })
        .then(res => {
            this.props.setStatusWindow({value: true, type: 'cabinet'});
            this.props.updatePreloader(false);
        })
    }

    _setVariableOptions(value) {
        const objOptions = JSON.parse(JSON.stringify(this.props.variableOptions));
        objOptions.positions = value.is_standwithtype ? value.is_standwithtype : false;
        objOptions.bicolor = value.is_bicolor ? value.is_bicolor : false;
        objOptions.cabinetsBicolor = value.bicolor ? value.bicolor : false;
        this.props.setVariableOptions(objOptions);
    }

    render() {

        return (
            <div className='options-list'>

                <button className='options-list__close'
                    onClick={()=>this.props.updatePart('')}
                >
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L18 18M18 18L35 35M18 18L35 1M18 18L1 35" stroke="black" strokeWidth="2"/>
                    </svg>
                </button>
                {this.props.part === 'stand' ? 
                    <>
                        <h2 className='options-list__title'>Выберите тумбу <br/>и редактируйте её</h2>
                        <div className='options-list__items'>
                            {stands.map((stand, i) => {
                                return (
                                    <button key={i} className={`options-list__item ${this.props.config.stand.stand.name === stand.name ? 'options-list__item--active' : ''}`}
                                        onClick={() => {
                                            this._getStandList(stand);
                                            this._setVariableOptions(stand);
                                        }}
                                    >
                                        <object className='options-list__button'>
                                            <button className="button button--icon">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M22.75 17.5C22.75 17.91 22.41 18.25 22 18.25H15V18.5C15 20 14.1 20.5 13 20.5H7C5.9 20.5 5 20 5 18.5V18.25H2C1.59 18.25 1.25 17.91 1.25 17.5C1.25 17.09 1.59 16.75 2 16.75H5V16.5C5 15 5.9 14.5 7 14.5H13C14.1 14.5 15 15 15 16.5V16.75H22C22.41 16.75 22.75 17.09 22.75 17.5Z" fill="#F9F9F9"/>
                                                    <path d="M22.75 6.5C22.75 6.91 22.41 7.25 22 7.25H19V7.5C19 9 18.1 9.5 17 9.5H11C9.9 9.5 9 9 9 7.5V7.25H2C1.59 7.25 1.25 6.91 1.25 6.5C1.25 6.09 1.59 5.75 2 5.75H9V5.5C9 4 9.9 3.5 11 3.5H17C18.1 3.5 19 4 19 5.5V5.75H22C22.41 5.75 22.75 6.09 22.75 6.5Z" fill="#F9F9F9"/>
                                                </svg>
                                            </button>
                                        </object>
                                        <div className='options-list__item-picture'>
                                            <img src={stand.img[0]}/>
                                        </div>
                                        <div className='options-list__item-description'>
                                            <span className='options-list__name'>{stand.name}</span>
                                            <span className='options-list__price'>от {Math.round(stand.price)} ₽</span>
                                        </div>
                                    </button>
                                )
                            })}
                        </div>
                    </>
                : 
                ""
                }
                {this.props.part === 'sink'
                ?
                <>
                    {
                        this.props.variableSinks.length <= 0 && this.props.variableTabletops.length <= 0 ?
                        <h2 className='options-list__title'>Для данной тумбы не представлены раковины и столешницы</h2>
                        :
                        <>
                            <h2 className='options-list__title'>Выберите раковину или столешницу <br/>и редактируйте её</h2>
                            <div className='options-list__buttons'>
                                {
                                    this.props.variableSinks.length > 0 ? 
                                    <button onClick = {() => this.props.updatePart('sink-choice')} className='button'>Раковина</button> 
                                    : 
                                    ''
                                }
                                {
                                    
                                    this.props.variableTabletops.length > 0 ?
                                    <button onClick = {() => {
                                        this.props.setStatusWindow({value: true, type: 'tabletop'})}
                                    } className='button'>Столешница</button>
                                    :
                                    ''
                                }

                        </div>
                        </>
                    }
                </>
                :
                ""
                }

                {this.props.part === 'sink-choice'
                ?
                <div className='options-list__items'>
                    {this.props.variableSinks.map((sink, i) => {
                        let image = false;
                        let currentSinkId = {}
                        sinks.forEach(item => {
                            if(item.name === sink.name) {
                                item.img.length > 0 ? image = item.img[0] : image = false;
                                currentSinkId = item;
                            }
                        })
                        return (
                            <button key={i} className={`options-list__item ${this.props.variableSinks.length > 0 && this.props.config.sink!==false ? this.props.config.sink.sink.name === sink.name ? 'options-list__item--active' : '' : ''}`}
                                onClick={() => {
                                    this.props.setStatusWindow({value: true, type: 'sink'})
                                    const currentSinks = this.props.allVariableSinks.filter(itemSink => {
                                        return sink.name === itemSink.name
                                    })
                                    this.props.initModal(currentSinkId.description, currentSinkId.img);
                                    this.props.updateCurrentSink(currentSinks);
                                }
                            }>
                                <object className='options-list__button'>
                                    <button className="button button--icon">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M22.75 17.5C22.75 17.91 22.41 18.25 22 18.25H15V18.5C15 20 14.1 20.5 13 20.5H7C5.9 20.5 5 20 5 18.5V18.25H2C1.59 18.25 1.25 17.91 1.25 17.5C1.25 17.09 1.59 16.75 2 16.75H5V16.5C5 15 5.9 14.5 7 14.5H13C14.1 14.5 15 15 15 16.5V16.75H22C22.41 16.75 22.75 17.09 22.75 17.5Z" fill="#F9F9F9"/>
                                            <path d="M22.75 6.5C22.75 6.91 22.41 7.25 22 7.25H19V7.5C19 9 18.1 9.5 17 9.5H11C9.9 9.5 9 9 9 7.5V7.25H2C1.59 7.25 1.25 6.91 1.25 6.5C1.25 6.09 1.59 5.75 2 5.75H9V5.5C9 4 9.9 3.5 11 3.5H17C18.1 3.5 19 4 19 5.5V5.75H22C22.41 5.75 22.75 6.09 22.75 6.5Z" fill="#F9F9F9"/>
                                        </svg>
                                    </button>
                                </object>
                                <div className='options-list__item-picture'>
                                    <img src={image ? image : img.tumba1}/>
                                </div>
                                <div className='options-list__item-description'>
                                    <span className='options-list__name'>{sink.name}</span>
                                    <span className='options-list__price'>от {Math.round(sink.mm12.price)} ₽</span>
                                </div>
                            </button>
                        )
                    })}
                </div>
                :
                <></>
                }

                {this.props.part === 'mirror' 
                ?
                <>
                    <h2 className='options-list__title'>Выберите зеркало <br/>и редактируйте его</h2>
                    <div className='options-list__items'>

                        {
                            mirrors.map((mirror, i) => {
                                return (
                                <button key={i} className={`options-list__item ${this.props.config.mirror!==false &&  this.props.config.mirror.mirror.name === mirror.name ? 'options-list__item--active' : ''}`} 
                                    onClick={() => {
                                        this._getMirrorList(mirror)
                                    }
                                }>
                                    <object className='options-list__button'>
                                        <button className="button button--icon">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M22.75 17.5C22.75 17.91 22.41 18.25 22 18.25H15V18.5C15 20 14.1 20.5 13 20.5H7C5.9 20.5 5 20 5 18.5V18.25H2C1.59 18.25 1.25 17.91 1.25 17.5C1.25 17.09 1.59 16.75 2 16.75H5V16.5C5 15 5.9 14.5 7 14.5H13C14.1 14.5 15 15 15 16.5V16.75H22C22.41 16.75 22.75 17.09 22.75 17.5Z" fill="#F9F9F9"/>
                                                <path d="M22.75 6.5C22.75 6.91 22.41 7.25 22 7.25H19V7.5C19 9 18.1 9.5 17 9.5H11C9.9 9.5 9 9 9 7.5V7.25H2C1.59 7.25 1.25 6.91 1.25 6.5C1.25 6.09 1.59 5.75 2 5.75H9V5.5C9 4 9.9 3.5 11 3.5H17C18.1 3.5 19 4 19 5.5V5.75H22C22.41 5.75 22.75 6.09 22.75 6.5Z" fill="#F9F9F9"/>
                                            </svg>
                                        </button>
                                    </object>
                                    <div className='options-list__item-picture'>
                                        <img src={mirror.img[0]}/>
                                    </div>
                                    <div className='options-list__item-description'>
                                        <span className='options-list__name'>{mirror.name}</span>
                                        <span className='options-list__price'>от {Math.round(mirror.price)} ₽</span>
                                    </div>
                                </button>
                                )
                            })
                        }
                    </div>
                </>
                :
                ""
                }

                {this.props.part === 'cabinet' 
                ?
                <>
                    <>
                    {
                        this.props.variableCabinets.length <= 0 ?
                        <h2 className='options-list__title'>Для данной тумбы не представлены пеналы</h2>
                        :
                        <>
                            <h2 className='options-list__title'>Выберите пенал <br/>и редактируйте его</h2>
                            <div className='options-list__items'>
                                {this.props.variableCabinets.map((cabinet, i) => {
                                    return (
                                        <button key={i} className={`options-list__item ${this.props.config.mirror!==false &&  this.props.config.cabinet.name === cabinet.name ? 'options-list__item--active' : ''}`} 
                                            onClick={() => {
                                                this._getCabinetList(cabinet);
                                                this._setVariableOptions(cabinet);
                                            }
                                        }>
                                            <object className='options-list__button'>
                                                <button className="button button--icon">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M22.75 17.5C22.75 17.91 22.41 18.25 22 18.25H15V18.5C15 20 14.1 20.5 13 20.5H7C5.9 20.5 5 20 5 18.5V18.25H2C1.59 18.25 1.25 17.91 1.25 17.5C1.25 17.09 1.59 16.75 2 16.75H5V16.5C5 15 5.9 14.5 7 14.5H13C14.1 14.5 15 15 15 16.5V16.75H22C22.41 16.75 22.75 17.09 22.75 17.5Z" fill="#F9F9F9"/>
                                                        <path d="M22.75 6.5C22.75 6.91 22.41 7.25 22 7.25H19V7.5C19 9 18.1 9.5 17 9.5H11C9.9 9.5 9 9 9 7.5V7.25H2C1.59 7.25 1.25 6.91 1.25 6.5C1.25 6.09 1.59 5.75 2 5.75H9V5.5C9 4 9.9 3.5 11 3.5H17C18.1 3.5 19 4 19 5.5V5.75H22C22.41 5.75 22.75 6.09 22.75 6.5Z" fill="#F9F9F9"/>
                                                    </svg>
                                                </button>
                                            </object>
                                            <div className='options-list__item-picture'>
                                                <img src={cabinet.img[0]}/>
                                            </div>
                                            <div className='options-list__item-description'>
                                                <span className='options-list__name'>{cabinet.name}</span>
                                                <span className='options-list__price'>от {Math.round(cabinet.price)} ₽</span>
                                            </div>
                                        </button>
                                    )})
                                }
                            </div>
                            
                        </>
                    }
                </>
                </>
                :
                <></>

                }
                
            </div>
        )
    }
}